import { atom } from "jotai";
import { DataColumn } from "../config/dataInterface";

export interface TenantPlan {
  plan_id: string;
  plan_name: string;
  max_partners: number;
  max_et_sites: number;
  has_payment: boolean;
  has_ai_analysis: boolean;
  current_partners: number;
  current_et_sites: number;
  monthly_price: number;
}

// 読み込み中かどうか
const isLoading = atom<boolean>(false);

// ログインしているかどうか
const isLogin = atom<boolean>(false);

// ログインユーザー情報
export interface loginUserDifine {
  idToken: string;
  username: string;
  authority: string;
  db_authority: string;
  company: string;
  title: string;
  color: string;
}
const loginUser = atom<loginUserDifine>();

// メニュー表示
const switchMenu = atom<boolean>(false);

// パス
const pathname = atom<string>("");

// スマートフォン表示
const isSmartPhone = atom<boolean>(false);

// カラム設定
// エントリー一覧
const contractScreenColumn = atom<DataColumn[]>([]);

// トスアップ一覧
const tossUpScreenColumn = atom<DataColumn[]>([]);

// ランキング一覧
const accountRunkingScreenColumn = atom<DataColumn[]>([]);

// テナントサブスクリプションプラン情報
const tenantPlanAtom = atom<TenantPlan | null>(null);

// サンプル質問（ページ名→質問配列の辞書）
const sampleQuestionsAtom = atom<Record<string, string[]>>({});

// Stage2 (DB getProfile) 完了フラグ
const profileLoaded = atom<boolean>(false);

export const AppAtoms = {
  isLoading,
  isLogin,
  loginUser,
  switchMenu,
  pathname,
  isSmartPhone,
  contractScreenColumn,
  tossUpScreenColumn,
  accountRunkingScreenColumn,
  tenantPlanAtom,
  sampleQuestionsAtom,
  profileLoaded,
};
